<template>
  <div class="image-container">
    <img :alt="altText" :src="imageUrl" :style="{ width: '100%', height: height + 'px' }" @click="showLargeImage" />
    <div v-if="isLargeImageVisible" class="large-image-container" @click="hideLargeImage">
      <img :src="imageUrl" class="large-image" style="opacity: 100 !important;"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePreview',
  props: {
    altText: {
      type: String,
      default: 'Image'
    },
    imageUrl: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      isLargeImageVisible: false
    }
  },
  methods: {
    showLargeImage () {
      this.isLargeImageVisible = true
    },
    hideLargeImage () {
      this.isLargeImageVisible = false
    }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  overflow: hidden;
}

.large-image-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.large-image {
  max-width: 80%;
  max-height: 80%;
}
</style>
